module.exports = __webpack_public_path__ + "img/selfie_example.e2a229c0.jpg";